<template>
  <input
    type="text"
    class="input input-bordered w-full focus:ring-2 focus:ring-primary"
    :value="modelValue"
    :placeholder="placeholder"
    @input="onInput" />
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

function onInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}
</script>
